import { Skeleton } from '@components/ui/skeleton';
import React from 'react';

/**
 * Skeleton mirroring the dimensions of `KpiStrip` so the layout doesn't jump
 * when real data arrives. Three KPI cards (matches Open / At-Risk / Breached)
 * plus the right-aligned online-members indicator.
 */
export function KpiStripSkeleton() {
  return (
    <div className="flex items-center gap-3 flex-wrap" aria-hidden="true">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="min-w-[160px] rounded-lg px-4 py-3 bg-muted/40">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="mt-2 h-8 w-12" />
        </div>
      ))}
      <span className="ml-auto inline-flex items-center gap-2 whitespace-nowrap">
        <Skeleton className="size-2 rounded-full" />
        <Skeleton className="h-4 w-32" />
      </span>
    </div>
  );
}
